import script from "./audit-logs.vue?vue&type=script&setup=true&lang=js"
export * from "./audit-logs.vue?vue&type=script&setup=true&lang=js"

import "./audit-logs.vue?vue&type=style&index=0&id=7c1d3fea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1d3fea"]])

export default __exports__